import { render } from "./PaymentBody.vue?vue&type=template&id=abdf696a"
import script from "./PaymentBody.vue?vue&type=script&lang=js"
export * from "./PaymentBody.vue?vue&type=script&lang=js"

import "./PaymentBody.vue?vue&type=style&index=0&id=abdf696a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__